if (!window.productImageSwapInitialized) {
  window.productImageSwapInitialized = true;

  document.addEventListener(
    'click',
    (event) => {
      if (!window.matchMedia('(max-width: 749px)').matches) return;

      const opener = event.target.closest('.product__modal-opener--image');
      const gallery = opener?.closest('media-gallery');
      const swapTrigger = gallery?.querySelector('[data-hover-media-id]');
      const currentMedia = opener?.closest('[data-media-id]');
      if (!swapTrigger || !currentMedia) return;

      const primaryMedia = swapTrigger.closest('[data-media-id]');
      const primaryMediaId = primaryMedia?.dataset.mediaId;
      const hoverMediaId = swapTrigger.dataset.hoverMediaId;
      const currentMediaId = currentMedia.dataset.mediaId;
      if (!primaryMediaId || !hoverMediaId) return;

      let targetMediaId;
      if (currentMediaId === primaryMediaId) {
        targetMediaId = hoverMediaId;
      } else if (currentMediaId === hoverMediaId) {
        targetMediaId = primaryMediaId;
      } else {
        return;
      }

      // Move the gallery itself so the matching thumbnail is selected as well.
      event.preventDefault();
      event.stopImmediatePropagation();
      gallery.setActiveMedia(targetMediaId, false);
    },
    true
  );
}
